import React, { useState } from "react";

const usePagination = (initialState = {}) => {
  const [state, setState] = useState({
    page: 1,
    perPage: 10,
    ...initialState,
  });

  const { page, perPage } = state;

  const handlePagination = (newState) => {
    setState((prev) => ({ ...prev, ...newState }));
  };
  return {
    page,
    perPage,
    handlePagination,
  };
};

export default usePagination;
